module.exports = __webpack_public_path__ + "static/media/mic.e3723fc1.png";